import { FC } from "react";
import { Box, HStack } from "@chakra-ui/react";

import { useSbpTransferStore } from "../../../../../../store/sbpTransferStore.ts";

export const SbpTransferPagePaymentTimeline: FC = () => {
  const term = useSbpTransferStore(state => state.term);
  const payments = Array.from({ length: term?.term ?? 0 }, (_, i) => i + 1);

  return (
    <HStack h="6px" mb="5px" spacing={1}>
      <Box flex="1" h="100%" bg="brand.500" borderRadius="999" />

      {payments.map(p => <Box key={p} flex="1" h="100%" bg="gray.50" borderRadius="999" />)}
    </HStack>
  );
};
